import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../api/dashboard.api';
import type { DashboardFilters } from '../types/dashboard.types';

// Query keys
export const dashboardKeys = {
  all: ['dashboard'] as const,
  summary: (filters?: DashboardFilters) => [...dashboardKeys.all, 'summary', filters] as const,
  categories: (filters?: DashboardFilters) => [...dashboardKeys.all, 'categories', filters] as const,
  types: (filters?: DashboardFilters) => [...dashboardKeys.all, 'types', filters] as const,
  segments: (filters?: DashboardFilters) => [...dashboardKeys.all, 'segments', filters] as const,
  regions: (filters?: DashboardFilters) => [...dashboardKeys.all, 'regions', filters] as const,
  localities: (filters?: DashboardFilters) => [...dashboardKeys.all, 'localities', filters] as const,
};

// Hooks
export const useDashboardSummary = (filters?: DashboardFilters) => {
  return useQuery({
    queryKey: dashboardKeys.summary(filters),
    queryFn: () => dashboardApi.getSummary(filters),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useDashboardCategories = (filters?: DashboardFilters) => {
  return useQuery({
    queryKey: dashboardKeys.categories(filters),
    queryFn: () => dashboardApi.getByCategories(filters),
    staleTime: 5 * 60 * 1000,
  });
};

export const useDashboardTypes = (filters?: DashboardFilters) => {
  return useQuery({
    queryKey: dashboardKeys.types(filters),
    queryFn: () => dashboardApi.getByTypes(filters),
    staleTime: 5 * 60 * 1000,
  });
};

export const useDashboardSegments = (filters?: DashboardFilters) => {
  return useQuery({
    queryKey: dashboardKeys.segments(filters),
    queryFn: () => dashboardApi.getBySegments(filters),
    staleTime: 5 * 60 * 1000,
  });
};

export const useDashboardRegions = (filters?: DashboardFilters) => {
  return useQuery({
    queryKey: dashboardKeys.regions(filters),
    queryFn: () => dashboardApi.getByRegions(filters),
    staleTime: 5 * 60 * 1000,
  });
};

export const useDashboardLocalities = (filters?: DashboardFilters) => {
  return useQuery({
    queryKey: dashboardKeys.localities(filters),
    queryFn: () => dashboardApi.getByLocalities(filters),
    staleTime: 5 * 60 * 1000,
  });
};